import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { ADGMPanel } from 'aurora-components';
import withStyles from '@material-ui/core/styles/withStyles';
import { Grid, Avatar } from '@material-ui/core';
import classNames from 'classnames';
import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import CompanyImage from 'aurora-images/avatar_profile.svg';
import { keyEmptyCheck } from 'aurora-utils/utils';
import ADGMTextField from '../ADGMTextField';
import styles from './styles';

const ADGMAttendeLists = ({ classes, title, attendeesList, updateAttendeesList }) => {
  const [updatedAttendeesList, setUpdatedAttendeesList] = useState(attendeesList);
  const handleChange = (index, newValue, key) => {
    const updatedAttendees = [...updatedAttendeesList];
    if (key === 'email') {
      updatedAttendees[index].email = newValue;
    }
    if (key === 'phone') {
      updatedAttendees[index].phoneNo = newValue;
    }
    setUpdatedAttendeesList(updatedAttendees);
    updateAttendeesList(updatedAttendees);
  };

  return (
    <ADGMPanel title={title}>
      <div className={classes.container}>
        {updatedAttendeesList &&
          updatedAttendeesList.map((attendee, index) => (
            <Grid
              key={attendee?.id}
              className={classNames(classes.listItem, updatedAttendeesList.length !== index + 1 && classes.itemParent)}
              container
            >
              <Grid item md={4}>
                <div style={{ display: 'flex' }}>
                  <Avatar className={classes.avatarImg} alt='avatar img' src={CompanyImage} />
                  <span>
                    <ADGMItemDetails
                      valueClass={classes.textInput}
                      label={
                        <span>
                          {keyEmptyCheck('attendee')} # {index + 1}
                        </span>
                      }
                      value={attendee.name}
                    />
                  </span>
                </div>
              </Grid>
              <Grid item md={4}>
                {!attendee?.editEmail ? (
                  <ADGMItemDetails
                    label={keyEmptyCheck('email')}
                    labelClass={classes.lightThinLabel}
                    value={attendee.email}
                    valueClass={classes.lightThinValue}
                  />
                ) : (
                  <ADGMTextField
                    type='text'
                    label={keyEmptyCheck('email')} // Change the label accordingly
                    name='email'
                    value={attendee.email || ''} // Initialize with the existing email value or an empty string
                    required
                    placeholder='Enter email'
                    customClasses={{
                      field: classes.textInput,
                      input: classes.textInput,
                    }}
                    InputLabelProps={{ shrink: true }}
                    onChange={e => handleChange(index, e.target.value, e.target.name)}
                  />
                )}
              </Grid>
              <Grid item md={4}>
                {!attendee?.editPhone ? (
                  <ADGMItemDetails
                    label={keyEmptyCheck('phone')}
                    labelClass={classes.lightThinLabel}
                    value={attendee.phoneNo}
                    valueClass={classes.lightThinValue}
                  />
                ) : (
                  <ADGMTextField
                    type='text'
                    label={keyEmptyCheck('phone')} // Change the label accordingly
                    name='phone'
                    value={attendee.phoneNo || ''} // Initialize with the existing phone number value or an empty string
                    required
                    placeholder='Enter mobile number'
                    customClasses={{
                      field: classes.textInput,
                      input: classes.textInput,
                    }}
                    InputLabelProps={{ shrink: true }}
                    onChange={e => handleChange(index, e.target.value, e.target.name)}
                  />
                )}
              </Grid>
            </Grid>
          ))}
      </div>
    </ADGMPanel>
  );
};

ADGMAttendeLists.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  attendeesList: PropTypes.array.isRequired,
  updateAttendeesList: PropTypes.func.isRequired,
};

export default withStyles(styles)(memo(ADGMAttendeLists));
